import React, { useState } from 'react';
import { User } from 'firebase';
import { Button, Table } from 'bloomer';
import { firebaseFunctions, firestore, firebaseAuth } from '../firebase/firebase';
import { saveAs } from 'file-saver';
import { exportReports } from '../shared/reports';
import { formatDateSeconds } from '../shared/date';
import startCase from 'lodash.startcase';

export function Reports({ user }: { user: User }) {
  const [reports, setReports] = useState<string[][] | null>(null);
  const [error, setError] = useState<Error | null>(null);

  if (!reports) loadData(setReports, setError);

  return (
    <div>
      <Button
        onClick={async (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => {
          e.preventDefault();
          try {
            const result = await firebaseFunctions.httpsCallable('exportReports')({ type: 'xlsx' });
            downloadReport(
              result,
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
              `${formatDateSeconds(new Date())}-reports.xlsx`
            );
          } catch (error) {
            console.error(error);
          }
        }}
      >
        Export XLSX
      </Button>{' '}
      <Button
        onClick={async (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => {
          e.preventDefault();
          try {
            const result = await firebaseFunctions.httpsCallable('exportReports')({ type: 'csv' });
            downloadReport(
              result,
              'text/csv;charset=utf-8',
              `${formatDateSeconds(new Date())}-reports.csv`
            );
          } catch (error) {
            console.error(error);
          }
        }}
      >
        Export CSV
      </Button>{' '}
      {error && <div>{error.message}</div>}
      {reports && renderReports(reports)}
    </div>
  );
}

function renderReports(reports: string[][]) {
  const [head, ...rest] = reports;
  return (
    <div className="table-container" style={{ fontSize: '0.7em', marginTop: '30px' }}>
      <Table isNarrow isStriped isFullWidth className="is-hoverable">
        <thead>
          <tr>
            {head.map(field => (
              <th key={field}>{startCase(field)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rest.map((values, index) => (
            <tr key={index}>
              {values.map((value, index) =>
                index <= 2 ? <th key={index}>{value}</th> : <td key={index}>{value}</td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

function downloadReport(result: { data: any }, type: string, filename: string) {
  const blob = new Blob([Buffer.from(result.data)], { type: type });
  saveAs(blob, filename, true);
}

async function loadData(
  setReports: React.Dispatch<React.SetStateAction<string[][] | null>>,
  setError: React.Dispatch<React.SetStateAction<Error | null>>
) {
  const uid = firebaseAuth.currentUser?.uid;
  if (!uid) throw new Error(`UID is not set`);
  try {
  } catch (error) {
    setError(error);
  }
  setReports(await exportReports(uid, firestore));
}
